import React, { useMemo } from 'react';
import classes from '../ui/Transactions.module.scss';
import { HistoryOutlined } from '@ant-design/icons';
import { Flex } from 'antd';
import { TransactionStatus, TransactionType } from 'widgets/transactions/model/types';

// Import transaction icons
import accountAdjustmentIcon from 'shared/assets/transactions/accountAdjustment.png';
import authorizationIcon from 'shared/assets/transactions/authorization.png';
import feeIcon from 'shared/assets/transactions/fee.png';
import otherIcon from 'shared/assets/transactions/other.png';

type TransactionIconProps = {
  size: number;
  type?: string;
  status?: string;
};

const TransactionIcon: React.FC<TransactionIconProps> = ({ size, type, status }) => {
  const icon = useMemo(() => {
    switch (type) {
      case TransactionType.AccountAdjustment:
        return accountAdjustmentIcon;
      case TransactionType.Fee:
      case TransactionType.ClearingFee:
      case TransactionType.BankFee:
        return feeIcon;
      case TransactionType.Authorization:
      case 'Transaction':
        return authorizationIcon;
      default:
        return otherIcon;
    }
  }, [type]);

  // Pending status indicator (small icon overlay)
  const pendingIndicator = status === TransactionStatus.Pending ? (
    <HistoryOutlined
      style={{ fontSize: size / 3, position: 'absolute', bottom: -1, right: -1 }}
    />
  ) : null;

  const iconSize = size * 0.6; // Уменьшаем размер в 2 раза

  return (
    <Flex
      justify="center"
      align="center"
      style={{ width: size, height: size, position: 'relative' }}
      className={classes['transaction__image']}>
      <img
        src={icon}
        alt="transaction icon"
        style={{ width: iconSize, height: iconSize, objectFit: 'contain' }}
      />
      {pendingIndicator}
    </Flex>
  );
};

export default TransactionIcon;
